
import { useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";

import { deleteEmployes } from "../../../../../MyApi/sb/employes";

import man from '../../../../../assets/images/dashboard/1.png';
import icons from "../../../../../Data/icons";

const SingleEmploy = ({ employ, classes ,refetch}) => {
  const { id,name_ar, name_en ,nation_id,role } = employ;
  const navigate = useNavigate()
  const {t}=useTranslation()

 const EyeIcon = icons.eye
 const EditIcon = icons.pen
 const TrashIcon = icons.trash
  const mutation =useMutation(["deleteemploy" , id] , ()=>deleteEmployes(id),{
    onSuccess:(data)=>{
     toast.success(`${data.message}`)
     refetch()
  
    },
    onError:(error)=>{
      toast.error(`${error.data.response.message}`)
    }
  })
 

  const deletePost =()=>{
    mutation.mutate()
  }
  return (

    <div class="box-col-6 col-md-6 col-lg-12 col-xl-4">
      <div class="custom-card card">
        <div class="card-profile">
        <img src={man} alt={name_en}  className="rounded-circle media"/>
        </div>
        <ul as="ul" class="simple-list card-social list-group list-group">
          <li class="list-group-item"><Link to={`${process.env.PUBLIC_URL}/employ/${id}`}><EyeIcon/></Link></li>
          <li class="list-group-item"><Link to={`${process.env.PUBLIC_URL}/employesupdate/${id}`}><EditIcon/></Link></li>
          <li class="list-group-item"><Link onClick={deletePost}><TrashIcon/></Link></li>  
        </ul>
        <a href={`${process.env.PUBLIC_URL}/employ/${id}`}>
          <div class="text-center profile-details"><h4>{name_ar}</h4><h6>{t(role)}</h6></div>
        </a>
      </div>
    </div>


  );
};

export default SingleEmploy;
